import React, { useState, useEffect } from 'react'
import axios from 'axios';
import Sidebar from '../Layouts/Sidebar'
import Topbar from '../Layouts/Topbar'
import './AdminDashboard.css'
import Swal from 'sweetalert2';

const base_url = 'https://api.homehive.co.zw';

const styles = {
  refreshBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    backgroundColor: '#1a237e',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  }
};

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalProperties: 0,
    totalUsers: 0,
    landlords: 0,
    tenants: 0,
    monthlyVisitors: 0,
    apkDownloads: 0,
    recentActivities: []
  });
  const [activeUsersData, setActiveUsersData] = useState({
    activeUsers: 0,
    monthlyActiveUsers: 0
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchActiveUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${base_url}/api/active-users`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log(response.data)
      setActiveUsersData({
        activeUsers: response.data.current_active_users['count'],
        monthlyActiveUsers: response.data.monthly_active_users['count']
      });
    } catch (error) {
      console.error('Error fetching active users:', error);
      // Don't show error toast for active users to avoid spam
    }
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${base_url}/api/admin-reports`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        console.log(response.data.metrics)
        setStats(response.data.metrics);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        Swal.fire({
          title: 'Error',
          text: 'Failed to load dashboard data',
          icon: 'error',
          confirmButtonColor: '#1a237e'
        });
        setIsLoading(false);
      }
    };

    fetchDashboardData();
    fetchActiveUsers(); // Initial fetch of active users

    // Set up polling intervals
    const dashboardInterval = setInterval(fetchDashboardData, 100000); // Every ~1.7 minutes
    const activeUsersInterval = setInterval(fetchActiveUsers, 60000); // Every 1 minute

    // Cleanup intervals on component unmount
    return () => {
      clearInterval(dashboardInterval);
      clearInterval(activeUsersInterval);
    };
  }, []);

  if (isLoading) {
    return (
      <div className="admin-dashboard">
        <Sidebar />
        <Topbar />
        <div className="dashboard-content loading">
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <Topbar />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-content">
            <h1>Dashboard Overview</h1>
            <p>Welcome back, Admin! Here's what's happening with your platform.</p>
          </div>
          <button 
            className="dashboard-refresh-btn"
            onClick={() => window.location.reload()}
          >
            <i className="fas fa-sync-alt"></i>
            <span>Refresh Data</span>
          </button>
        </div>

        <div className="stats-grid">
          {/* Total Properties Card */}
          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'rgba(26, 35, 126, 0.1)' }}>
              <i className="fas fa-home" style={{ color: '#1a237e' }}></i>
            </div>
            <div className="stat-info">
              <h3>Total Properties</h3>
              <p className="stat-number">{stats.totalProperties}</p>
              
            </div>
          </div>

          {/* Total Users Card */}
          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'rgba(76, 175, 80, 0.1)' }}>
              <i className="fas fa-users" style={{ color: '#4caf50' }}></i>
            </div>
            <div className="stat-info">
              <h3>Total Users</h3>
              <p className="stat-number">{stats.totalUsers}</p>
             
            </div>
          </div>

          {/* Landlords Card */}
          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'rgba(255, 152, 0, 0.1)' }}>
              <i className="fas fa-user-tie" style={{ color: '#ff9800' }}></i>
            </div>
            <div className="stat-info">
              <h3>Landlords</h3>
              <p className="stat-number">{stats.totalLandlords}</p>
              
            </div>
          </div>

          {/* Tenants Card */}
          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'rgba(233, 30, 99, 0.1)' }}>
              <i className="fas fa-user-friends" style={{ color: '#e91e63' }}></i>
            </div>
            <div className="stat-info">
              <h3>Tenants</h3>
              <p className="stat-number">{stats.totalTenants}</p>
              
            </div>
          </div>

          {/* Active Users Card */}
          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'rgba(33, 150, 243, 0.1)' }}>
              <i className="fas fa-user-check" style={{ color: '#2196f3' }}></i>
            </div>
            <div className="stat-info">
              <h3>Active Users</h3>
              <p className="stat-number">{activeUsersData.activeUsers}</p>
            </div>
          </div>

          {/* Monthly Visitors Card */}
          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'rgba(156, 39, 176, 0.1)' }}>
              <i className="fas fa-chart-line" style={{ color: '#9c27b0' }}></i>
            </div>
            <div className="stat-info">
              <h3>Monthly Visitors</h3>
              <p className="stat-number">{activeUsersData.monthlyActiveUsers}</p>
              
            </div>
          </div>

        </div>

        {/* Recent Activity Section */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>Recent Activity</h2>
            <span className="activity-count">{stats.recentActivities?.length || 0} activities</span>
          </div>
          <div className="activity-list">
            {stats.recentActivities && stats.recentActivities.length > 0 ? (
              stats.recentActivities.map((activity, index) => (
                <div key={index} className="activity-item">
                  <div className="activity-icon">
                    <i className={`fas ${activity.icon || 'fa-bell'}`}></i>
                  </div>
                  <div className="activity-details">
                    <p>{activity.description}</p>
                    <span>{activity.timeAgo}</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-activities">
                <i className="fas fa-inbox"></i>
                <p>No recent activities</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
